export interface PaymentItem {
    productId: string;
    quantity: number;
  }

  export interface PaymentResponse {
    clientSecret: string;
    status: string;
    amount: number;
  }

  export interface BillingReducer {
    loading: boolean;
    error: string | null;
    success: boolean;
    response: PaymentResponse | null;
    items: PaymentItem[],
  }

  export const PAYMENT_REQUEST = 'PAYMENT_REQUEST';
  export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
  export const PAYMENT_FAILURE = 'PAYMENT_FAILURE';

  interface PaymentRequestAction {
    type: typeof PAYMENT_REQUEST;
    payload: PaymentItem[];
  }

  interface PaymentSuccessAction {
    type: typeof PAYMENT_SUCCESS;
    payload: PaymentResponse;
  }

  interface PaymentFailureAction {
    type: typeof PAYMENT_FAILURE;
    payload: string;
  }

  export type PaymentActionTypes =
    | PaymentRequestAction
    | PaymentSuccessAction
    | PaymentFailureAction;

    export type ActionPayment =
  | { type: typeof PAYMENT_REQUEST }
  | { type: typeof PAYMENT_SUCCESS; payload: PaymentResponse }
  | { type: typeof PAYMENT_FAILURE; payload: string }
